import { Badge, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useCallback, useEffect, useRef, useState } from "react";
import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import ModalImage from "react-modal-image";
import eyeIcon from "../../../assets/images/icons/eye.svg"
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export default function TripListOfUser({ trips }) {

    const [searchParams, setSearchParams] = useSearchParams();
    const [perPage, setPerPage] = useState(10)
    const [tripsToDisplay, setTripsToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    useEffect(() => {
        setTripsToDisplay(trips.filter((item) => {
            if (search === "") return true;
            if (moment(item.date).format("DD/MM/YY").toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.manualDistance?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.autoCalculatedDistance?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.totalExpense?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.totalNewCustomers?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.tasksCompleted?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.tasks?.length.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.isStarted === true && "started".startsWith(search.toLowerCase())) return true;
            if (item.isStarted === false && "scheduled".startsWith(search.toLowerCase())) return true;
            if (item.isCompleted === true && !item?.isNotEnded && "completed".startsWith(search.toLowerCase())) return true;
            if (item.isCompleted === false && moment().startOf('day').valueOf() === item.date && "on going".startsWith(search.toLowerCase())) return true;
            if (((item.isCompleted === false && moment().startOf('day').valueOf() !== item.date) || item?.isNotEnded) && item?.isStarted && "not ended".startsWith(search.toLowerCase())) return true;
            return false;
        }))
    }, [search, trips])



    const columns = [
        {
            name: "Date",
            center: true,
            selector: (row) => `${moment(row?.date).format("DD/MM/YY")}`,
            sortable: true,
        },
        {
            name: "Status",
            center: true,
            selector: (row) => {
                if (!row?.isStarted) {
                    return <Badge bg="info" text="white">Scheduled</Badge>
                }
                else if (!row?.isCompleted) {
                    if (moment().startOf('day').valueOf() !== row.date) {
                        return <Badge bg="info" text="white">Not Ended</Badge>
                    }
                    return <Badge bg="warning" text="white">On Going</Badge>
                }
                else {
                    if (row?.isNotEnded) {
                        return <Badge bg="danger" text="white">Not Ended</Badge>
                    }
                    return <Badge bg="success" text="white">Completed</Badge>
                }
            }
        },
        {
            name: "Start Time",
            center: true,
            selector: "startTime",
            sortable: true,
            cell: (row) => {
                if (row?.isStarted) {
                    return <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {`${parseFloat(row?.startKM).toFixed(2)} km`}
                        </Tooltip>}>


                        <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

                            <span className="d-flex align-items-center">
                                {parseFloat(row?.startKM) > 0 && `${parseFloat(row?.startKM).toFixed(2)} km`}

                                {row?.startImage !== "" && <ModalImage
                                    showRotate={true}
                                    className="ms-2"
                                    hideDownload={true}
                                    small={eyeIcon}
                                    large={row?.startImage}
                                    alt="Start Image"
                                />}
                            </span>
                            <p className="m-0">{moment(row?.startTime).format("hh:mm A")}</p>
                        </span>
                    </OverlayTrigger>
                }
                return "-"

            }
        },
        {
            name: "End Time",
            center: true,
            selector: "endTime",
            sortable: true,
            cell: (row) => {
                if (row?.isCompleted) {
                    return <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {`${parseFloat(row?.endKM).toFixed(2)} km`}
                        </Tooltip>}>


                        <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

                            <span className="d-flex align-items-center">
                                {parseFloat(row?.endKM) > 0 && `${parseFloat(row?.endKM).toFixed(2)} km`}

                                {row?.endImage !== "" && <ModalImage
                                    showRotate={true}
                                    className="ms-2"
                                    hideDownload={true}
                                    small={eyeIcon}
                                    large={row?.endImage}
                                    alt="Start Image"
                                />}
                            </span>
                            <p className="m-0">{moment(row?.endTime).format("hh:mm A")}</p>
                        </span>
                    </OverlayTrigger>
                }
                return "-"

            }
        },
        {
            name: "Manual km",
            center: true,
            selector: "manualKM",
            cell: (row) => {
                if (row?.manualDistance) {
                    return `${parseFloat(row?.manualDistance / 1000).toFixed(2)} km`
                }
                return "-"
            },
            sortable: true,
        },
        {
            name: "Auto KM",
            center: true,
            selector: "autoCalculatedDistance",
            cell: (row) => `${(row?.autoCalculatedDistance / 1000).toFixed(2)} km`,
            sortable: true,
        },
        {
            name: "New Customers",
            center: true,
            selector: (row) => row?.totalNewCustomers,
            sortable: true,
        },
        {
            name: "Expense",
            center: true,
            selector: (row) => `${parseFloat(row?.totalExpense).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Route",
            center: true,
            width: "400px",
            selector: "tasks",
            cell: (row) => {
                if (row?.trip === false) {
                    return "-"
                }
                if(row?.route && row?.route !== ""){
                    return row?.route
                }
                let str = ""

                let tasks = row?.tasks || []
                for (let i = 0; i < tasks?.length; i++) {
                    if (i === 0) {
                        if (tasks[i]?.destinationArea) {
                            str += `${tasks[i]?.destinationArea}, `
                        }
                        if (tasks[i]?.destinationCity) {
                            str += `${tasks[i]?.destinationCity}, `
                        }
                        if (tasks[i]?.destinationState) {
                            str += `${tasks[i]?.destinationState}, `
                        }
                    } else {
                        if (str !== "") {
                            str += " -> "
                        }

                        if (tasks[i]?.destinationArea && tasks[i]?.destinationArea !== row?.tasks[i - 1]?.destinationArea) {
                            str += `${tasks[i]?.destinationArea}, `
                        }
                        if (tasks[i]?.destinationCity && tasks[i]?.destinationCity !== row?.tasks[i - 1]?.destinationCity) {
                            str += `${tasks[i]?.destinationCity}, `
                        }
                        if (tasks[i]?.destinationState && tasks[i]?.destinationState !== row?.tasks[i - 1]?.destinationState) {
                            str += `${tasks[i]?.destinationState}, `
                        }
                    }

                }
                return str
            }
        },
        {
            name: "Action",
            center: true,
            selector: (row) => {
                return <Link to={`/dashboard/trips/${row?.id}`}>View</Link>
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Trip List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                </div>
                                {<DataTable
                                    defaultSortAsc={false}
                                    columns={columns}
                                    data={tripsToDisplay}
                                    pagination={true}
                                    paginationPerPage={searchParams.get("perPage") ? parseInt(searchParams.get("perPage")) : 10}
                                    paginationDefaultPage={searchParams.get("page") ? parseInt(searchParams.get("page")) : 1}
                                    onChangeRowsPerPage={(e, page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("perPage", e)
                                        setSearchParams(currentSearchParam)
                                    }}

                                    onChangePage={(page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("page", page)
                                        setSearchParams(currentSearchParam)
                                    }}
                                />}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}